import { Navigate, useLocation } from "react-router-dom";

export default function CommitteesRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/person/committees to /people/:pgaId/membership/committees
  const newPath = location.pathname.replace("/person/committees", "/membership/committees");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
